import QueryString from "qs";
import mainAxios from "../api/mainAxios";

export const getAgencies = () => async (dispatch) => {
  try {
    dispatch({ type: "GET_AGENCES_LOADING" });

    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const query = QueryString.stringify({
      populate: {
        logo: {
          fields: ["id"],
          populate: {
            image: { fields: ["url"] },
          },
        },
      },

      pagination: {
        pageSize: 1000,
      },
    });

    const response = await mainAxios.get(`api/agences?${query}`, config);

    dispatch({ type: "GET_AGENCES_SUCCESS", payload: response.data });
  } catch (error) {
    console.error("error", error);
    dispatch({ type: "GET_AGENCES_FAILURE", payload: error.message });
  }
};

export const syncAgencies = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch({ type: "GET_AGENCES_LOADING" });

    await mainAxios.post(`api/sync-immodvisor`, config);

    dispatch(getAgencies());
  } catch (error) {
    console.error("error", error);
    dispatch({ type: "GET_AGENCES_FAILURE", payload: error.message });
  }
};
